module.exports = __webpack_public_path__ + "static/media/next-icon-cold-hand-towel-o.e95fad0c.svg";